module.exports = __webpack_public_path__ + "img/hart-removebg-preview.ef4b89e8.png";